import Form from '../form/Form';
import Description from 'lib/src/components/typography/Description';
import Modal from './Modal';

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    closeModal,
    handleSubmit,
    error,
    isPosting,
    title = 'Confirm',
    description = 'Are you sure?',
    submitText = 'Confirm',
    cancelText = 'Cancel',
    submitColor = 'green',
}) => {
    return (
        <Modal closeModal={closeModal} title={title} size="small">
            <Description>{description}</Description>
            <Form
                error={error}
                onSubmit={handleSubmit}
                onCancel={closeModal}
                isPosting={isPosting}
                submitText={submitText}
                cancelText={cancelText}
                submitColor={submitColor}
            />
        </Modal>
    );
};
interface ConfirmModalProps {
    closeModal: () => void;
    handleSubmit: () => void;
    error?: string | null;
    isPosting?: boolean;
    title?: string;
    description?: string;
    submitText?: string;
    cancelText?: string;
    submitColor?: string;
}

export default ConfirmModal;
